export default __webpack_public_path__ + "static/14-min-d94c5a7e5421c6318333293af753ab36.png";